import React from "react";
import { AdapterIcon } from "../../../../../../generic/icon/component-icon/component-icon";

interface EndpointsDropdownOption {
    spriteID: string;
    CPHumanName: string;
    CPName: string;
}

const EndpointsDropdownOption: React.FC<EndpointsDropdownOption> = ({ CPHumanName, CPName, spriteID }) => {
    return (
        <>
            <AdapterIcon spriteId={spriteID} useNative name={CPName} size={36} showBorder={false} />
            <div>{CPHumanName}</div>
        </>
    );
};

export default EndpointsDropdownOption;
